/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_OkInputs */

const en_tut_akses_ok = /** @type {(inputs: Tut_Akses_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The badge on the room card changes to the mode you chose, and an accepted request becomes an invitation you can revoke later.`)
};

const id_tut_akses_ok = /** @type {(inputs: Tut_Akses_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge pada kartu ruang berubah sesuai mode yang dipilih, dan permintaan yang diterima menjadi undangan yang bisa dicabut kapan saja.`)
};

/**
* | output |
* | --- |
* | "The badge on the room card changes to the mode you chose, and an accepted request becomes an invitation you can revoke later." |
*
* @param {Tut_Akses_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_ok = /** @type {((inputs?: Tut_Akses_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_ok(inputs)
	return en_tut_akses_ok(inputs)
});